import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressPortfolioPortfolioappMediaServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/portfolio-app-service',
        destPath: '/api',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/portfolio-app-service',
        destPath: '/api',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/portfolio-app-service',
        destPath: '/api',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/portfolio-app-service',
        destPath: '/api',
      },
    ],
    _: [
      {
        srcPath: '/_api/portfolio-app-service',
        destPath: '/api',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/_api/portfolio-app-service',
        destPath: '/api',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/portfolio/v1/settings',
        destPath: '/api/v1/portfolio/settings',
      },
      {
        srcPath: '/portfolio/portfolio-app/api/v1/portfolio/settings',
        destPath: '/api/v1/portfolio/settings',
      },
      {
        srcPath:
          '/portfolio/project-items/api/v1/portfolio/project/items/media',
        destPath: '/api/v1/portfolio/project/items/media',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/portfolio/portfolio-app/api/v1/portfolio/settings',
        destPath: '/api/v1/portfolio/settings',
      },
      {
        srcPath:
          '/portfolio/project-items/api/v1/portfolio/project/items/media',
        destPath: '/api/v1/portfolio/project/items/media',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/create',
        destPath: '/api/v1/bulk/portfolio/items/create',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/items/duplicate',
        destPath: '/api/v1/items/duplicate',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/delete',
        destPath: '/api/v1/bulk/portfolio/items/delete',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/update',
        destPath: '/api/v1/bulk/portfolio/items/update',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/portfolio/v1/projectItems',
        destPath: '/api/v1/portfolio/projects',
      },
      {
        srcPath: '/portfolio/v1/items',
        destPath: '/api/v1/portfolio/items',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/create',
        destPath: '/api/v1/bulk/portfolio/items/create',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/items/duplicate',
        destPath: '/api/v1/items/duplicate',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/delete',
        destPath: '/api/v1/bulk/portfolio/items/delete',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/update',
        destPath: '/api/v1/bulk/portfolio/items/update',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/portfolio/items',
        destPath: '/api/v1/portfolio/items',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/portfolio/projects',
        destPath: '/api/v1/portfolio/projects',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/project-items-service',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/create',
        destPath: '/api/v1/bulk/portfolio/items/create',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/items/duplicate',
        destPath: '/api/v1/items/duplicate',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/delete',
        destPath: '/api/v1/bulk/portfolio/items/delete',
      },
      {
        srcPath: '/portfolio/project-items/api/v1/bulk/portfolio/items/update',
        destPath: '/api/v1/bulk/portfolio/items/update',
      },
      {
        srcPath: '/_api/project-items-service',
        destPath: '/api',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_portfolio_project-items';

/** Creates a project item. */
export function createProjectItem(payload: object): RequestOptionsFactory<any> {
  function __createProjectItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'item.sortOrder' },
          { path: 'item.image.focalPoint.x' },
          { path: 'item.image.focalPoint.y' },
          { path: 'item.image.unsharpMasking.amount' },
          { path: 'item.image.unsharpMasking.radius' },
          { path: 'item.image.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'item.createdDate' },
          { path: 'item.updatedDate' },
          { path: 'item.image.imageInfo.urlExpirationDate' },
          { path: 'item.video.videoInfo.urlExpirationDate' },
          { path: 'item.video.videoInfo.resolutions.poster.urlExpirationDate' },
          { path: 'item.video.videoInfo.posters.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.CreateProjectItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/portfolio/items',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.image.focalPoint.x' },
              { path: 'item.image.focalPoint.y' },
              { path: 'item.image.unsharpMasking.amount' },
              { path: 'item.image.unsharpMasking.radius' },
              { path: 'item.image.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.image.imageInfo.urlExpirationDate' },
              { path: 'item.video.videoInfo.urlExpirationDate' },
              {
                path: 'item.video.videoInfo.resolutions.poster.urlExpirationDate',
              },
              { path: 'item.video.videoInfo.posters.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createProjectItem;
}

/**
 * Creates multiple project items.
 *
 * To create a single project item, call Create Project Item.
 */
export function bulkCreateProjectItems(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkCreateProjectItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'items.sortOrder' },
          { path: 'items.image.focalPoint.x' },
          { path: 'items.image.focalPoint.y' },
          { path: 'items.image.unsharpMasking.amount' },
          { path: 'items.image.unsharpMasking.radius' },
          { path: 'items.image.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'items.createdDate' },
          { path: 'items.updatedDate' },
          { path: 'items.image.imageInfo.urlExpirationDate' },
          { path: 'items.video.videoInfo.urlExpirationDate' },
          {
            path: 'items.video.videoInfo.resolutions.poster.urlExpirationDate',
          },
          { path: 'items.video.videoInfo.posters.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.BulkCreateProjectItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/bulk/portfolio/items/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.item.sortOrder' },
              { path: 'results.item.image.focalPoint.x' },
              { path: 'results.item.image.focalPoint.y' },
              { path: 'results.item.image.unsharpMasking.amount' },
              { path: 'results.item.image.unsharpMasking.radius' },
              { path: 'results.item.image.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.image.imageInfo.urlExpirationDate' },
              { path: 'results.item.video.videoInfo.urlExpirationDate' },
              {
                path: 'results.item.video.videoInfo.resolutions.poster.urlExpirationDate',
              },
              {
                path: 'results.item.video.videoInfo.posters.urlExpirationDate',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateProjectItems;
}

/** Retrieves a project item. */
export function getProjectItem(payload: object): RequestOptionsFactory<any> {
  function __getProjectItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.GetProjectItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/portfolio/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.image.focalPoint.x' },
              { path: 'item.image.focalPoint.y' },
              { path: 'item.image.unsharpMasking.amount' },
              { path: 'item.image.unsharpMasking.radius' },
              { path: 'item.image.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.image.imageInfo.urlExpirationDate' },
              { path: 'item.video.videoInfo.urlExpirationDate' },
              {
                path: 'item.video.videoInfo.resolutions.poster.urlExpirationDate',
              },
              { path: 'item.video.videoInfo.posters.urlExpirationDate' },
            ],
          },
        ]),
      fallback: [
        {
          method: 'GET' as any,
          url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
            protoPath: '/api/v1/portfolio/items/{itemId}',
            data: payload,
            host,
          }),
          params: toURLSearchParams(payload),
        },
      ],
    };

    return metadata;
  }

  return __getProjectItem;
}

/** Retrieves a list of all project items in the specified project. */
export function listProjectItems(payload: object): RequestOptionsFactory<any> {
  function __listProjectItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.ListProjectItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/portfolio/projects/{projectId}/items',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'items.sortOrder' },
              { path: 'items.image.focalPoint.x' },
              { path: 'items.image.focalPoint.y' },
              { path: 'items.image.unsharpMasking.amount' },
              { path: 'items.image.unsharpMasking.radius' },
              { path: 'items.image.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.createdDate' },
              { path: 'items.updatedDate' },
              { path: 'items.image.imageInfo.urlExpirationDate' },
              { path: 'items.video.videoInfo.urlExpirationDate' },
              {
                path: 'items.video.videoInfo.resolutions.poster.urlExpirationDate',
              },
              { path: 'items.video.videoInfo.posters.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listProjectItems;
}

/** Updates a project item. */
export function updateProjectItem(payload: object): RequestOptionsFactory<any> {
  function __updateProjectItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'item.sortOrder' },
          { path: 'item.image.focalPoint.x' },
          { path: 'item.image.focalPoint.y' },
          { path: 'item.image.unsharpMasking.amount' },
          { path: 'item.image.unsharpMasking.radius' },
          { path: 'item.image.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'item.createdDate' },
          { path: 'item.updatedDate' },
          { path: 'item.image.imageInfo.urlExpirationDate' },
          { path: 'item.video.videoInfo.urlExpirationDate' },
          { path: 'item.video.videoInfo.resolutions.poster.urlExpirationDate' },
          { path: 'item.video.videoInfo.posters.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.UpdateProjectItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/portfolio/items/{item.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.image.focalPoint.x' },
              { path: 'item.image.focalPoint.y' },
              { path: 'item.image.unsharpMasking.amount' },
              { path: 'item.image.unsharpMasking.radius' },
              { path: 'item.image.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.image.imageInfo.urlExpirationDate' },
              { path: 'item.video.videoInfo.urlExpirationDate' },
              {
                path: 'item.video.videoInfo.resolutions.poster.urlExpirationDate',
              },
              { path: 'item.video.videoInfo.posters.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateProjectItem;
}

/**
 * Updates multiple project items.
 *
 * To update a single project item, call Update Project Item.
 */
export function bulkUpdateProjectItems(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateProjectItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'items.fieldMask' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'items.item.sortOrder' },
          { path: 'items.item.image.focalPoint.x' },
          { path: 'items.item.image.focalPoint.y' },
          { path: 'items.item.image.unsharpMasking.amount' },
          { path: 'items.item.image.unsharpMasking.radius' },
          { path: 'items.item.image.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'items.item.createdDate' },
          { path: 'items.item.updatedDate' },
          { path: 'items.item.image.imageInfo.urlExpirationDate' },
          { path: 'items.item.video.videoInfo.urlExpirationDate' },
          {
            path: 'items.item.video.videoInfo.resolutions.poster.urlExpirationDate',
          },
          { path: 'items.item.video.videoInfo.posters.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.BulkUpdateProjectItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/bulk/portfolio/items/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.item.sortOrder' },
              { path: 'results.item.image.focalPoint.x' },
              { path: 'results.item.image.focalPoint.y' },
              { path: 'results.item.image.unsharpMasking.amount' },
              { path: 'results.item.image.unsharpMasking.radius' },
              { path: 'results.item.image.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.image.imageInfo.urlExpirationDate' },
              { path: 'results.item.video.videoInfo.urlExpirationDate' },
              {
                path: 'results.item.video.videoInfo.resolutions.poster.urlExpirationDate',
              },
              {
                path: 'results.item.video.videoInfo.posters.urlExpirationDate',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateProjectItems;
}

/** Deletes a project item. */
export function deleteProjectItem(payload: object): RequestOptionsFactory<any> {
  function __deleteProjectItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.DeleteProjectItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/portfolio/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteProjectItem;
}

/**
 * Deletes multiple project items.
 *
 * To delete a single project item, call Delete Project Item.
 */
export function bulkDeleteProjectItems(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkDeleteProjectItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.BulkDeleteProjectItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/bulk/portfolio/items/delete',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __bulkDeleteProjectItems;
}

/**
 * Duplicates project items from one project (the origin) to another project (the target).
 *
 * <blockquote class="important">
 * <strong>Important:</strong>
 *
 * Both the origin and target projects must exist before calling this method.
 * </blockquote>
 */
export function duplicateProjectItems(
  payload: object
): RequestOptionsFactory<any> {
  function __duplicateProjectItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.portfolio.projectitems.ProjectItemsService.DuplicateProjectItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioProjectitemsProjectItemsServiceUrl({
        protoPath: '/api/v1/items/duplicate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __duplicateProjectItems;
}

/** Generate media token for project items */
export function generateTokenForProjectItems(
  payload: object
): RequestOptionsFactory<any> {
  function __generateTokenForProjectItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.portfolio.project_items.v1.project_item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.portfolio.portfolioapp.MediaService.GenerateTokenForProjectItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPortfolioPortfolioappMediaServiceUrl({
        protoPath: '/api/v1/portfolio/project/items/media',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __generateTokenForProjectItems;
}
